import { useEffect, useState } from 'react';
import './LoadingStatus.css';

// The status line next to the waiting eye (EyeBadge): what wheniseeus is
// doing right now, a phrase that changes every few seconds while the model
// generates (the reply arrives all at once, so there is no real progress to
// show), and the seconds it has been waiting. Same phrases as
// vscode-extension/media/chat.js and browser-extension/sidepanel.js.
const PHRASES = {
  es: {
    searching: ['Buscando en internet…'],
    thinking: ['Pensando…', 'Ordenando ideas…', 'Armando la respuesta…', 'Cuidando los detalles…'],
    designing: [
      'Diseñando tu página…',
      'Eligiendo tipografías…',
      'Armando el hero…',
      'Dando forma a las secciones…',
      'Escribiendo los textos…',
      'Sumando hovers y transiciones…',
      'Ajustando para celular…'
    ],
    sources: (n) => (n === 1 ? 'Leyendo 1 fuente…' : `Leyendo ${n} fuentes…`)
  },
  en: {
    searching: ['Searching the web…'],
    thinking: ['Thinking…', 'Sorting out ideas…', 'Putting the answer together…', 'Minding the details…'],
    designing: [
      'Designing your page…',
      'Picking typefaces…',
      'Building the hero…',
      'Shaping the sections…',
      'Writing the copy…',
      'Adding hovers and transitions…',
      'Tuning it for phones…'
    ],
    sources: (n) => (n === 1 ? 'Reading 1 source…' : `Reading ${n} sources…`)
  }
};

const ROTATE_EVERY_S = 3;

export function formatElapsed(seconds) {
  if (seconds < 60) return `${seconds}s`;
  const m = Math.floor(seconds / 60);
  return `${m}m ${String(seconds % 60).padStart(2, '0')}s`;
}

export default function LoadingStatus({ status, diseno, sourcesCount = 0, language = 'es' }) {
  const [elapsed, setElapsed] = useState(0);
  const [phraseStart, setPhraseStart] = useState(0);

  // Mounted once per request (the loader unmounts when the reply lands).
  useEffect(() => {
    const started = Date.now();
    const id = setInterval(() => setElapsed(Math.floor((Date.now() - started) / 1000)), 250);
    return () => clearInterval(id);
  }, []);

  // Each new status starts its own phrase list from the top.
  useEffect(() => {
    setPhraseStart(elapsed);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status]);

  const p = PHRASES[language] || PHRASES.es;
  let phrases;
  if (status === 'searching') phrases = p.searching;
  else if (status === 'designing') phrases = p.designing;
  else phrases = sourcesCount > 0 ? [p.sources(sourcesCount), ...p.thinking.slice(1)] : p.thinking;
  const phrase = phrases[Math.floor((elapsed - phraseStart) / ROTATE_EVERY_S) % phrases.length];

  const combo = status === 'designing' && diseno ? [diseno.estilo, diseno.paleta, diseno.estructura].filter(Boolean).join(' · ') : '';

  return (
    <span className="loading-status" aria-live="off">
      <span className="loading-status-line">
        <span className="loading-status-text" key={phrase}>{phrase}</span>
        <span className="loading-status-time" aria-hidden="true">{formatElapsed(elapsed)}</span>
      </span>
      {combo && <span className="loading-status-combo" title={combo}>{combo}</span>}
    </span>
  );
}
